/**
 * DemoProvenanceBanner — specs/simulation-lab/demo-dataset-replay-and-provenance.md.
 *
 * Visible only on the public demo (`isDemoMode()`), never on a real client's reference
 * deployment — same `window.__WOWYRD_RUNTIME_DEMO_MODE__` mechanism the latency-hiding fix already
 * uses (see utils/formatting.ts's own doc comment for why a direct `import.meta.env.*` read
 * doesn't survive minification). States plainly that the live feed is synthetic, shaped from a
 * real, licensed fraud dataset (PaySim, CC BY-SA 4.0) — the label itself is this feature's
 * licence attribution, not just a UX nicety.
 */

import React from 'react';
import { useT } from '../../i18n';
import { isDemoMode } from '../../utils/formatting';

export const DemoProvenanceBanner: React.FC = () => {
  const { t } = useT();

  if (!isDemoMode()) {
    return null;
  }

  return (
    <span
      className="text-xs text-wyrd-ember border border-wyrd-ember-dim rounded px-2 py-0.5 whitespace-nowrap"
      title={t('demo.provenance.tooltip')}
    >
      {t('demo.provenance.label')}
    </span>
  );
};

export default DemoProvenanceBanner;
